import Reveal from "./Reveal";

/**
 * Eyebrow + h2 heading used by the home page sections.
 *
 * @component
 */

const SectionHeading = ({ eyebrow, title, id, children }) => (
  <Reveal className="sectionHeading">
    <p className="sectionEyebrow">{eyebrow}</p>
    <h2 className="sectionTitle" id={id}>
      {title}
    </h2>
    {children && <p className="sectionLead">{children}</p>}
  </Reveal>
);

export default SectionHeading;
